interface ToggleProps {
  label: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

export function Toggle({ label, checked = false, onChange, disabled = false }: ToggleProps) {
  return (
    <label className={`flex items-center gap-3 ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
      <div className="relative inline-flex h-6 w-10 shrink-0 items-center">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange?.(e.target.checked)}
          disabled={disabled}
          className="sr-only peer"
        />
        {/* Track */}
        <div className="h-6 w-10 rounded-full bg-tertiary transition-colors duration-200 peer-checked:bg-primary peer-disabled:opacity-50" />
        {/* Thumb */}
        <div className="absolute left-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200 peer-checked:translate-x-4" />
      </div>
      <span className="text-sm text-muted-foreground select-none">
        {label}
      </span>
    </label>
  );
}